import React from "react"
import "@transferwise/neptune-css/dist/css/neptune.css"
import "@transferwise/icons/lib/styles/main.min.css"
import { Link } from "gatsby"
import { CASFER_FX_URL } from "gatsby-env-variables"

import "@fontsource/patua-one"
import "@fontsource/nanum-gothic"
import "./styles.scss"
import "../../styles/neptuneoverride.css"
import "../../styles/currency-flag.css"
import styles from "./styles.module.scss"
import casferStyles from "../../styles/casfer.module.scss"
import responsive from "../../styles/responsive.css"

import CasferBrand from "../../assets/casfer-brand.svg"
import CasferLogo from "../../assets/casferlogo.png"
import CasferFooterBrand from "../../assets/casfer-footer-brand.svg"
import ArrowRight from "../../assets/arrow-right.svg"
import WebIcon from "../../assets/web-icon.svg"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAngleDown } from "@fortawesome/free-solid-svg-icons"
import { Modal, Select, Size } from "@transferwise/components"
import { init } from "../FreshchatHelper"

import {
  Provider,
  getLangFromLocale,
  translations as componentTranslations,
} from "@transferwise/components"
import messageEn from "../../translation/en.json"
import messageId from "../../translation/id.json"
import { FormattedMessage } from "react-intl"
import { connect } from "react-redux"
import { setLanguage, setLocale } from "../../app/intlSlice"
import "@fortawesome/fontawesome-svg-core/styles.css"
import { config } from "@fortawesome/fontawesome-svg-core"
config.autoAddCss = false

const languages = {
  en: messageEn,
  id: messageId,
}

const languageName = ["EN", "ID"]

class PageWrapper extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isNavBarBurgerOpen: false,
      selectedLanguage: {
        value:
          typeof window !== "undefined" && sessionStorage.getItem("lang")
            ? sessionStorage.getItem("lang")
            : "iD",
        label:
          typeof window !== "undefined" && sessionStorage.getItem("lang")
            ? sessionStorage.getItem("lang")
            : "ID",
      },
    }
  }

  componentDidMount() {
    init()
    window.addEventListener("resize", this.appHeight())
  }

  appHeight = () => {
    const doc = document.documentElement
    let vh = window.innerHeight * 0.01
    doc.style.setProperty("--vh", `${vh}px`)
  }

  changeLanguage = lang => {
    this.props.dispatch(setLanguage(lang.toLocaleLowerCase()))
    this.props.dispatch(setLocale(lang.toLocaleLowerCase()))
    sessionStorage.setItem("lang", lang)
  }

  selectLanguage = e => {
    this.setState({
      selectedLanguage: { value: e.value, label: e.label },
    })
    this.changeLanguage(e.value)
  }

  renderNavBar = () => {
    const navbarBurgerClass =
      this.state &&
      this.state.isNavBarBurgerOpen !== null &&
      this.state.isNavBarBurgerOpen
        ? "is-active"
        : ""
    const selectedLanguage = this.state
    return (
      <nav
        className="navbar is-transparent is-fixed-top"
        role="navigation"
        aria-label="main navigation"
      >
        <div className="container">
          <div className="navbar-brand">
            <Link to="/" className="navbar-item">
              <img src={CasferLogo} className={styles.casferBrand} />
            </Link>

            <a
              role="button"
              className={`navbar-burger ${navbarBurgerClass}`}
              aria-label="menu"
              aria-expanded="false"
              data-target="casferNavbar"
              onClick={() => {
                this.setState({
                  ...this.state,
                  isNavBarBurgerOpen: !this.state.isNavBarBurgerOpen,
                })
              }}
            >
              <span aria-hidden="true" />
              <span aria-hidden="true" style={{ marginTop: "0.9rem" }} />
              <span aria-hidden="true" />
            </a>
          </div>

          <div id="casferNavbar" className={`navbar-menu ${navbarBurgerClass}`}>
            <div className="navbar-end">
              {/* tampilan dekstop */}
              <div className="navbar-item is-hidden-mobile is-hidden-tablet-only">
                <Link
                  to="/"
                  className="navbar-item navbar-menu-text"
                  activeClassName="is-active"
                >
                  <FormattedMessage id="home" />
                </Link>
                <Link
                  to="/about"
                  className="navbar-item navbar-menu-text"
                  activeClassName="is-active"
                >
                  <FormattedMessage id="about" />
                </Link>
                <Link
                  to="/faq"
                  className="navbar-item navbar-menu-text"
                  activeClassName="is-active"
                >
                  <FormattedMessage id="faq" />
                </Link>
                <Link
                  to="/legal/privacy-policy"
                  className="navbar-item navbar-menu-text"
                  activeClassName="is-active"
                >
                  <FormattedMessage id="privacy" />
                </Link>
                <Link
                  to="/legal/service-agreement"
                  className="navbar-item navbar-menu-text"
                  activeClassName="is-active"
                >
                  <FormattedMessage id="agreement" />
                </Link>
                <div className="button-container">
                  <a
                    className={`login-btn button is-rounded is-fullwidth ${casferStyles.casferButtonLight}`}
                    href={`${CASFER_FX_URL}/#/?redirect=/sign-in`}
                  >
                    Login
                  </a>
                </div>
                <div className="button-container">
                  <a
                    className="login-btn button is-rounded is-fullwidth btn-register"
                    href={`${CASFER_FX_URL}/#/?redirect=/sign-up`}
                  >
                    Register
                  </a>
                </div>
                <div className="language-switch navbar-item">
                  <Select
                    id="language-switch-select"
                    size="sm"
                    dropdownWidth="md"
                    inverse={true}
                    block
                    disabled={false}
                    required={false}
                    selected={this.state.selectedLanguage}
                    onChange={this.selectLanguage}
                    options={[
                      { value: "ID", label: "ID" },
                      { value: "EN", label: "EN" },
                    ]}
                  />
                </div>
              </div>

              {/* tampilan mobile */}
              <div className="navbar-item is-hidden-desktop">
                <div className="menu-responsive">
                  <div className="responsive-menu">
                    <Link
                      to="/"
                      onClick={() => {
                        this.setState({
                          isNavBarBurgerOpen: !this.state.isNavBarBurgerOpen,
                        })
                      }}
                    >
                      <span>
                        <a href="#">
                          <FormattedMessage id="home" />
                        </a>
                        <img
                          src={ArrowRight}
                          className={`arrow-right ${styles.stepImages}`}
                        />
                      </span>
                    </Link>
                  </div>
                  <div className="responsive-menu">
                    <Link
                      to="/about"
                      onClick={() => {
                        this.setState({
                          isNavBarBurgerOpen: !this.state.isNavBarBurgerOpen,
                        })
                      }}
                    >
                      <span>
                        <a href="#">
                          <FormattedMessage id="about" />
                        </a>
                        <img
                          src={ArrowRight}
                          className={`arrow-right ${styles.stepImages}`}
                        />
                      </span>
                    </Link>
                  </div>
                  <div className="responsive-menu">
                    <Link
                      to="/faq"
                      onClick={() => {
                        this.setState({
                          isNavBarBurgerOpen: !this.state.isNavBarBurgerOpen,
                        })
                      }}
                    >
                      <span>
                        <a href="#">
                          <FormattedMessage id="faq" />
                        </a>
                        <img
                          src={ArrowRight}
                          className={`arrow-right ${styles.stepImages}`}
                        />
                      </span>
                    </Link>
                  </div>
                  <div className="responsive-menu">
                    <Link
                      to="/legal/privacy-policy"
                      onClick={() => {
                        this.setState({
                          isNavBarBurgerOpen: !this.state.isNavBarBurgerOpen,
                        })
                      }}
                    >
                      <span>
                        <a href="#">
                          <FormattedMessage id="privacy" />
                        </a>
                        <img
                          src={ArrowRight}
                          className={`arrow-right ${styles.stepImages}`}
                        />
                      </span>
                    </Link>
                  </div>
                  <div className="responsive-menu">
                    <Link
                      to="/legal/service-agreement"
                      onClick={() => {
                        this.setState({
                          isNavBarBurgerOpen: !this.state.isNavBarBurgerOpen,
                        })
                      }}
                    >
                      <span>
                        <a href="#">
                          <FormattedMessage id="agreement" />
                        </a>
                        <img
                          src={ArrowRight}
                          className={`arrow-right ${styles.stepImages}`}
                        />
                      </span>
                    </Link>
                  </div>
                  <div className={`${styles.switcherMobile}`}>
                    {languageName.map(language => (
                      <a
                        onClick={() => this.changeLanguage(language)}
                        value={language}
                        key={language}
                        className={
                          language.toLocaleLowerCase() === this.props.language
                            ? `${styles.langActive}`
                            : `${styles.langNotActive}`
                        }
                      >
                        {language}
                      </a>
                    ))}
                  </div>
                </div>
                <div className="buttons" style={{ marginTop: "3rem" }}>
                  <a
                    className={`button btn-responsive-regis is-rounded is-fullwidth ${casferStyles.casferButtonLight}`}
                    href={`${CASFER_FX_URL}/#/?redirect=/sign-in`}
                  >
                    Login
                  </a>
                </div>
                <div className="buttons">
                  <a
                    className={`button btn-responsive-regis is-rounded is-fullwidth btn-register`}
                    href={`${CASFER_FX_URL}/#/?redirect=/sign-up`}
                  >
                    Register
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    )
  }

  renderFooter = () => (
    <React.Fragment>
      <div className="is-fluid">
        <div
          className={`separator-footer is-hidden-mobile ${styles.footerSeparator}`}
        />
      </div>
      <div className={`is-fullwidth ${styles.casferFooter}`}>
        <div className="container">
          <footer className="footer">
            <div className="block has-text-centered">
              <h4 className="is-4 start-casfer">Start Saving with Casfer.</h4>
              <a
                className={`button btn-start-casfer is-rounded ${casferStyles.casferButtonFooter}`}
                href={`${CASFER_FX_URL}#/?redirect=/sign-up`}
              >
                Get Started
              </a>
            </div>
            <div className="block footer-container">
              <div className="columns">
                <div className="column is-one-third">
                  <div className="block">
                    <figure className="image">
                      <img
                        src={CasferFooterBrand}
                        className={styles.footerBrand}
                      />
                    </figure>
                  </div>
                  <div className="footer-item">
                    <Link to="/" style={{ color: "white" }}>
                      Home
                    </Link>
                  </div>
                  <div className="footer-item">
                    <Link to="/about" style={{ color: "white" }}>
                      About
                    </Link>
                  </div>
                  <div className="footer-item">
                    <Link to="/faq" style={{ color: "white" }}>
                      FAQ
                    </Link>
                  </div>
                  <div className="footer-item">
                    <Link to="/legal/privacy-policy" style={{ color: "white" }}>
                      Privacy Policy
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="block footer-container">
              &copy; Casfer. All rights reserved 2022.
            </div>
          </footer>
        </div>
      </div>
    </React.Fragment>
  )

  render() {
    const { locale, language } = this.props
    const lang = getLangFromLocale(locale)
    const messages = { ...componentTranslations[lang], ...languages[language] }
    const modalText =
      "We help you get the cheapest rate for your transactions. Fast and easy transactions from anywhere and any device !"
    return (
      <Provider i18n={{ locale, messages }}>
        <React.Fragment>
          {this.renderNavBar()}
          <div
            className="section-announcement marquee marquee-wrap"
            onClick={() => this.setState({ open: true })}
          >
            <span>{modalText}</span>
          </div>
          <Modal
            body={
              <>
                <p className="m-t-4" style={{ maxLines: 1 }}>
                  We help you get the cheapest rate for your transactions. Fast
                  and easy transactions from anywhere and any device!
                </p>
              </>
            }
            open={this.state.open}
            size={Size.LARGE}
            onClose={() => this.setState({ open: false })}
            title="Announcement!"
            className="modal-container"
          >
            closeOnClick
          </Modal>
          {this.props.children}

          {this.renderFooter()}
        </React.Fragment>
      </Provider>
    )
  }
}

const mapStateToProps = state => {
  return state.intl
}

export default connect(mapStateToProps)(PageWrapper)
